module.exports = __webpack_public_path__ + "static/media/icon_mpm.ca2c9309.png";